module.exports = __webpack_public_path__ + "images/help/icn-videoplay-db093de60b2fd0b16fecbe1245db05b3.png";